import Flag from 'LuxKit/Flag'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import type { MouseEvent, MouseEventHandler } from 'react'
import { useCallback, useMemo } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  region: App.RegionSummary
  onRegionClick: (region: App.RegionSummary, event: MouseEvent<HTMLButtonElement>) => void
}

function RegionListItem(props: Props) {
  const { region, onRegionClick } = props
  const intl = useIntl()

  const regionDisplayNames = useMemo(
    () => new Intl.DisplayNames(intl.locale, { type: 'region' }),
    [intl.locale],
  )
  const regionName = regionDisplayNames.of(region.code) ?? region.name

  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    onRegionClick(region, event)
  }, [onRegionClick, region])

  const ariaLabel = intl.formatMessage(
    {
      id: 'x0jJNYdj7O06XdnutNQA',
      defaultMessage: 'Select {regionName} region',
      description: 'Accessibility label for selecting a region in the site header',
    },
    { regionName },
  )

  return <ClickableListItem
    data-regioncode={region.code}
    aria-label={ariaLabel}
    size="medium"
    startIcon={<Flag countryCode={region.code} />}
    title={regionName}
    onClick={handleClick}
  />
}

export default RegionListItem
